export enum InvoicesOlsaMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_INVOICES_OLSA = 'SET_INVOICES_OLSA',
  SET_SELECTED_INVOICE_OLSA = 'SET_SELECTED_INVOICE_OLSA',
  SET_ERROR = 'SET_ERROR'
}
